export default function SectionHeading({ overline, title, subtitle, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {overline && (
        <div className="text-sm font-semibold tracking-[0.18em] uppercase text-[#081537] mb-3">
          {overline}
        </div>
      )}
      <h2 className="font-[Outfit] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A] text-balance">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
}
